import styled from "styled-components";

export const StyledAppliedMessage = styled.div`
  display: "flex" block;
  justify-content: "center";
`;

export const StyledHeading = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  margin-bottom: 1.5rem;

  .cvp-h1 {
    color: var(--primary-600);
  }

  img {
    max-width: 300px;
    max-height: 120px;
    min-height: 120px; // prevent moving content when image is loaded
    object-fit: contain;
    margin-left: auto;
    margin-bottom: 1rem;
  }
`;

export const StyledSubHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;

  h2 {
    color: var(--text-color-secondary);
  }
  p {
    font-weight: 500;
    font-size: 0.9em;
  }
`;
